





























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { NotificationModule } from '@/app/store/modules/notifications'

@Component
export default class extends Vue {
  @Prop({}) public idModal
  @Prop({}) public id
  @Prop({}) public title
  @Prop({}) public content
  @Prop({}) public deletable

  public titles: string = ''
  public changeTitle(e) {
    this.titles = e
  }

  public contents: string = ''
  public changeContent(e) {
    this.contents = e
  }

  public resetEditModal() {
    this.title = ''
    this.content = ''
    this.deletable = 'false'
  }

  public get validTitle(): boolean {
    return this.title.length >= 4 ? true : false
  }

  public get validContent(): boolean {
    return this.content.length >= 4 ? true : false
  }

  public async patchNotif(item, index, button) {
    if (this.validTitle === false || this.validContent === false) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        title: this.titles === '' ? this.title : this.titles,
        content: this.contents === '' ? this.content : this.contents,
        deletable: this.deletable,
      }
      NotificationModule.updateNotification(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'edit-notification', button)
    }
  }
}
